/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  Existed,
  MapString,
  MapStringString,
  OauthLocation,
  WebexConnection,
  WebexConnections,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V1<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "webex";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description Get Webex connection
   *
   * @tags connections
   * @name GetWebexConnection
   * @request GET:/v1/tenant/{tenantId}/oauth/connection
   * @secure
   */
  getWebexConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      WebexConnection,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connection`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWebexConnection */
  getWebexConnectionPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/oauth/connection`);

  /**
   * @description Delete Webex connection
   *
   * @tags connections
   * @name DeleteWebexConnection
   * @request DELETE:/v1/tenant/{tenantId}/oauth/connection
   * @secure
   */
  deleteWebexConnection = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      Existed,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connection`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWebexConnection */
  deleteWebexConnectionPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/connection`);

  /**
   * @description Get Webex connections for a list of users
   *
   * @tags connections
   * @name GetWebexConnectionsForAListOfUsers
   * @request POST:/v1/tenant/{tenantId}/oauth/connections
   * @secure
   */
  getWebexConnectionsForAListOfUsers = (tenantId: string, data?: string[], params: RequestParams = {}) =>
    this.request<
      WebexConnections,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/connections`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWebexConnectionsForAListOfUsers */
  getWebexConnectionsForAListOfUsersPathGetter = (tenantId: string) =>
    this.getServicePath(`/v1/tenant/${tenantId}/oauth/connections`);

  /**
   * @description Initiate OAuth
   *
   * @tags oauth
   * @name InitiateOAuth
   * @request GET:/v1/tenant/{tenantId}/oauth/initiate
   * @secure
   */
  initiateOAuth = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      OauthLocation,
      | string
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v1/tenant/${tenantId}/oauth/initiate`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for initiateOAuth */
  initiateOAuthPathGetter = (tenantId: string) => this.getServicePath(`/v1/tenant/${tenantId}/oauth/initiate`);

  /**
   * @description Complete OAuth
   *
   * @tags oauth
   * @name CompleteOAuth
   * @request GET:/v1/public/oauth/callback
   */
  completeOAuth = (
    query: {
      /** @minLength 1 */
      code?: string;
      /** @minLength 1 */
      error?: string;
      /** @minLength 1 */
      state: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      any,
      | void
      | string
      | (
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapString;
              data?: any;
            }
          | {
              errorCode: string;
              errorMessage: string;
              arguments?: MapStringString;
            }
        )
    >({
      path: `/v1/public/oauth/callback`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Returns string containing request path for completeOAuth */
  completeOAuthPathGetter = (query: {
    /** @minLength 1 */
    code?: string;
    /** @minLength 1 */
    error?: string;
    /** @minLength 1 */
    state: string;
  }) => this.getServicePath(`/v1/public/oauth/callback`, query);
}
